var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 1.40718L31.7989 17.4904L31.9192 17.7975L32.2485 17.8156L49.6385 18.7733L36.1428 29.6601L35.8831 29.8696L35.9692 30.192L40.4233 46.8574L25.776 37.5107L25.5 37.3345L25.224 37.5107L10.5767 46.8574L15.0308 30.192L15.1169 29.8696L14.8572 29.6601L1.36148 18.7733L18.7515 17.8156L19.0808 17.7975L19.2011 17.4904L25.5 1.40718Z",
    stroke: "#F5B922",
    strokeWidth: 1.02633
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.19445b1d106119357da107d28d656ca2.svg";
export { ForwardRef as ReactComponent };